import React from 'react';
import { Card } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { hasMinimumLength } from '@/utils/resultsHelper';
import TrimmedMarkdownRender from '../text-editors/TrimmedMarkdownRender';

const CardItemDescription = ({
  className,
  linkTarget,
  maxChars = 500,
  maxLines = 10,
  value,
  href,
  markdown,
  withShowMore,
}) => (
  <Card.Description className={clsx('aridhia-card-item-description', className)}>
    {!markdown && !hasMinimumLength(href) && (<>{value}</>)}
    {markdown && (
      <TrimmedMarkdownRender
        className={className}
        linkTarget={linkTarget}
        maxChars={maxChars}
        maxLines={maxLines}
        suffix="ellipses"
        text={value}
        withShowMore={withShowMore}
      />
    )}
    {hasMinimumLength(href) && !markdown && (
      <Link to={href} title={value}>
        {value}
      </Link>
    )}
  </Card.Description>
);

export default CardItemDescription;
